import { createFileRoute } from "@tanstack/react-router";
import {
  About,
  Contact,
  Footer,
  Hero,
  Marquee,
  CrossedRibbons,
  BrandMarquee,
  Work,
} from "@/components/site/Sections";
import { SiteNav } from "@/components/site/SiteNav";
import { InteractiveServices } from "@/components/site/InteractiveServices";
import { HorizontalSEO } from "@/components/site/HorizontalSEO";
import { 
  ProgrammaticTargeting, 
  DeviceSimulator, 
  MediaTurbine, 
  BreezeFlight, 
  TestimonialsSpiral,
  ParticleWaves,
  AgencyVision
} from "@/components/site/VisualStorytelling";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "KMWA — Kris Media Work Advertising · Digital Agency" },
      {
        name: "description",
        content:
          "KMWA is a futuristic digital advertising studio building brands, performance campaigns, websites and creative content that move faster.",
      },
      { property: "og:title", content: "KMWA — We build brands that move faster." },
      {
        property: "og:description",
        content:
          "Creative thinking. Performance mindset. Technology-first execution. Digital advertising, branding, SEO, web, video and influencer marketing.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Index,
});

export function Index() {
  return (
    <div className="dark relative min-h-screen bg-background text-foreground flex flex-col w-full overflow-x-clip">
      <div className="relative z-10 bg-background shadow-[0_15px_50px_rgba(0,0,0,0.8)] border-b border-white/5 w-full overflow-x-clip">
        <SiteNav />
        <main className="w-full overflow-x-clip">
          <Hero />
          <BrandMarquee />
          <Marquee />
          <About />
          <InteractiveServices />
          <HorizontalSEO />
          <Work />
          <ProgrammaticTargeting />
          <DeviceSimulator />
          <MediaTurbine />
          <BreezeFlight />
          <ParticleWaves />
          <AgencyVision />
          <TestimonialsSpiral />
          <CrossedRibbons />
          <Contact />
        </main>
      </div>
      <Footer />
    </div>
  );
}
